module.exports = __webpack_public_path__ + "static/img/WB700.9d4ffc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/WB700.jpg
// module id = QzQm
// module chunks = 0